import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import SelectField from "../Utils/SelectField";
import { LabelText } from "../Utils/Input";

export const CustomerCategory = ({
  setFieldError,
  values,
  errors,
  touched,
  setFieldTouched,
  setFieldValue,
  handleBlur,
  categoryOptions,
}) => {
  return (
    <>
      <h4 className="card-title mb-0 flex-grow-1 rv-form-title">
        Categories
        <span className="numeric-code fs-6 rv-sub-label rv-label-muted">
          {" "}
          (Only one type of tag is allowed)
        </span>
      </h4>

      <Row className="pe-2">
        <Col xxl={6} md={6} className="pe-0">
          <LabelText
            htmlFor={"categories"}
            classLabelName={"d-block ms-0 my-2 rv-sub-label rv-label-muted"}
            displayText={"Enter your Categories"}
          />
          <SelectField
            className={
              (errors.categories && touched.categories) || false
                ? "error-input"
                : ""
            }
            value={
              categoryOptions?.find((category) => {
                category.label === values.categories.label;
              }) || values.categories
            }
            placeholder={" "}
            handleChange={(value) => {
              setFieldValue(`categories`, value, false);
              setFieldTouched(`categories`, false);
            }}
            name={"categories"}
            fieldName={"categories"}
            setFieldValue={setFieldValue}
            errors={errors.categories}
            handleBlur={handleBlur}
            touched={touched.categories}
            options={categoryOptions}
            isRVStyle={true}
          />
          {errors.categories && (
            <p className="text-danger validation-font-size">
              You can select only up to 1 options
            </p>
          )}
        </Col>
      </Row>
    </>
  );
};
